import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// REDUX
import { shallowEqual, useDispatch, useSelector } from "react-redux";

// CONTEXT
import { getListDocumentation } from "app/redux/documentation/actions/getListDocumentaton";
import { isEqual, isFunction } from "lodash";
import { useCallback } from "react";
import { AESEncryptURL } from "utils/encryption/AESEncrypt";
import { initialFilter } from "./DocumentationUIHelper";

const DocumentationUIContext = createContext();

export const useDocumentationUIContext = () => {
  return useContext(DocumentationUIContext);
};

export function DocumentationUIProvider({ children }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { getListDocumentationData } = useSelector(
    (state) => ({
      getListDocumentationData: state.GetListDocumentationData,
    }),
    shallowEqual
  );
  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  useEffect(() => {
    dispatch(getListDocumentation(queryParams));
  }, [dispatch, queryParams]);

  const setQueryParams = useCallback(
    (nextQueryParams) => {
      dispatch(getListDocumentation(nextQueryParams));
      setQueryParamsBase((prevQueryParams) => {
        if (isFunction(nextQueryParams)) {
          nextQueryParams = nextQueryParams(prevQueryParams);
        }
        if (isEqual(prevQueryParams, nextQueryParams)) {
          return prevQueryParams;
        }
        return nextQueryParams;
      });
    },
    [dispatch]
  );

  const dataUIEvents = {
    gotoCreateDocumentation: () => {
      navigate(`/documentation/create`, {
        state: {
          showDialog: true,
        },
      });
    },
    goToEditDocumentation: (data) => {
      const secureID = AESEncryptURL(data.id.toString());
      navigate(`/documentation/${secureID}/edit`, {
        state: {
          showDialog: true,
          documentationData: data,
        },
      });
    },
    onHide: () => {
      navigate(-1);
    },
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    getListDocumentationData,
    goToDeleteDocumentation: dataUIEvents.goToDeleteDocumentation,
    goToEditDocumentation: dataUIEvents.goToEditDocumentation,
    gotoCreateDocumentation: dataUIEvents.gotoCreateDocumentation,
    onHide: dataUIEvents.onHide,
  };

  return (
    <DocumentationUIContext.Provider value={value}>
      {children}
    </DocumentationUIContext.Provider>
  );
}
